module.exports = __webpack_public_path__ + "img/lock-closed-outline.fb4604e0.svg";